import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";

class Line extends Component {
    state = {  }
    render() { 
        return (
            <Col md ={12}><Col md ={12} style={{backgroundColor:this.props.color, marginTop: 10, marginBottom: 10}}></Col></Col>
        );
    }
}
 
export default Line;



// WEBPACK FOOTER //
// ./src/components/Line/Line.jsx